import { Stepper } from '@velocity/ui'
import { useMemo } from 'react'

import { useContent } from '@ngb-frontend/shared/context'

export const AppStepper: React.FC<{
  activeStep: number
  steps: string[]
}> = ({ steps, activeStep }) => {
  const c = useContent()
  const stepLabels = useMemo(
    () =>
      steps.map((step, index) => (
        <Stepper.Step key={index}>{c(step)}</Stepper.Step>
      )),
    [steps, c],
  )
  return (
    <Stepper
      activeStep={activeStep}
      aria-label="Booking progress"
      margin={{ top: '09', bottom: '08' }}
    >
      {stepLabels}
    </Stepper>
  )
}
